module.exports = __webpack_public_path__ + "assets/d7e8473dd3bda6070d5579220d8ca1de.png";